import { useMemo } from "react";

const fragments = [
  "0x4F52", "SCAN::OK", "137.2ms", "κ=0.91", "idx_7f3a", "PUBLISH",
  "▸ ACTIVE", "NODE_12", "lat:51.5", "2026-04", "::ffff", "SEO_OK",
  "Δ+4.2%", "ORBIT", "READY", "0xDEAD", "sig:OK", "λ=780",
];

const OriParticles = ({ density = "low" }: { density?: "low" | "high" }) => {
  const count = density === "high" ? 60 : 35;

  const particles = useMemo(() => {
    return Array.from({ length: count }, (_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      size: Math.random() * 2 + 1,
      opacity: Math.random() * 0.3 + 0.05,
      delay: Math.random() * 8,
      duration: Math.random() * 6 + 4,
    }));
  }, [count]);

  const texts = useMemo(() => {
    return Array.from({ length: density === "high" ? 12 : 6 }, (_, i) => ({
      id: i,
      left: `${Math.random() * 90 + 5}%`,
      top: `${Math.random() * 90 + 5}%`,
      text: fragments[i % fragments.length],
      opacity: Math.random() * 0.08 + 0.02,
      delay: Math.random() * 10,
    }));
  }, [density]);

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {particles.map((p) => (
        <div
          key={p.id}
          className="absolute rounded-full bg-[#00ff88]"
          style={{
            left: p.left,
            top: p.top,
            width: p.size,
            height: p.size,
            opacity: p.opacity,
            animation: `ori-float ${p.duration}s ease-in-out ${p.delay}s infinite alternate`,
          }}
        />
      ))}
      {texts.map((t) => (
        <span
          key={`t-${t.id}`}
          className="absolute font-mono text-[9px] text-[#00ff88] select-none"
          style={{
            left: t.left,
            top: t.top,
            opacity: t.opacity,
            animationDelay: `${t.delay}s`,
            animation: `ori-float ${8 + t.delay}s ease-in-out infinite alternate`,
          }}
        >
          {t.text}
        </span>
      ))}
    </div>
  );
};

export default OriParticles;
